import React from 'react';

import {assert} from 'Asserts';
import {MinimalFolder} from 'constants/FolderConstants';
import * as SourceConstants from 'constants/SourceConstants';
import FolderDAO from 'file-browser/FolderDAO';
import FolderSelectTree from 'file-browser/FolderSelectTree';
import SecondaryFilterFormSkeleton from 'search/filters/base/SecondaryFilterFormSkeleton';
import {FilterKey, GenericFilter} from 'search/SearchConstants';
import Button, {ButtonStyle} from 'ui-library/buttons/Button';
import Dropdown from 'ui-library/dropdowns/Dropdown';
import {CenteredHorizontalThrobber} from 'ui-library/HorizontalThrobber';
import MenuPopover from 'ui-library/menus/MenuPopover';
import pickDefined from 'util/pickDefined';

import {BASE_FILTER_FORM_PROP_NAMES, BaseFilterFormProps, FilterStyle} from './base/FilterFormConstants';

interface Props extends BaseFilterFormProps {
  filter: GenericFilter<FilterKey.PROJECT_FOLDER>;
  filterStyle: FilterStyle;
  onChangeFilter: (filter: GenericFilter<FilterKey.PROJECT_FOLDER>) => void;
  onRemove: () => void;
}

interface State {
  projectFolders: Array<MinimalFolder> | null;
}

class ProjectFolderFilterForm extends React.Component<Props, State> {
  override state: State = {
    projectFolders: null,
  };

  override componentDidMount(): void {
    FolderDAO.fetchAll({level: 'read'}).done((folders: Array<MinimalFolder>) => {
      const projectFolders = folders.filter(
        (folder) => folder.source!.sourceType !== SourceConstants.REGISTRY_TYPE
      );
      this.setState({projectFolders});
    });
  }

  _handleSelectFolder = (folderId: string | null): void => {
    this.props.onChangeFilter({
      ...this.props.filter,
      value: folderId,
    });
  };

  override render(): JSX.Element {
    const skeletonProps = pickDefined(this.props, ...BASE_FILTER_FORM_PROP_NAMES);
    const folderSelectTree =
      this.state.projectFolders != null ? (
        <FolderSelectTree
          allowNone={true}
          className="u-no-spacing-bottom folderFilter-selectTree"
          folders={this.state.projectFolders}
          folderIds={this.props.filter.value ? [String(this.props.filter.value)] : []}
          onChangeSelectedFolders={(folderIds: Array<string>) => {
            assert(folderIds.length <= 1, 'Expected 1 or fewer folders');
            this._handleSelectFolder(folderIds.length ? folderIds[0] : null);
          }}
          multiple={false}
        />
      ) : (
        <CenteredHorizontalThrobber />
      );
    const selectedFolder = this.state.projectFolders
      ? this.state.projectFolders.find((folder) => folder.api_identifier === this.props.filter.value)
      : null;
    const folderDropdown = (
      <Dropdown closeOnInsideClick={false} menu={<MenuPopover>{folderSelectTree}</MenuPopover>}>
        <Button
          buttonStyle={ButtonStyle.TERTIARY_GRAY}
          fullWidth={true}
          isDropdown={selectedFolder == null}
          size={this.props.buttonSize}
          text={selectedFolder ? selectedFolder.name : 'Any'}
          disabled={this.props.isDisabled}
        />
      </Dropdown>
    );
    return (
      <SecondaryFilterFormSkeleton
        {...skeletonProps}
        nodeGrid={[[folderDropdown]]}
        onChangeFilterKey={this.props.onChangeFilterKey}
        selectedFilterKey={this.props.selectedFilterKey}
        onRemove={this.props.onRemove}
      />
    );
  }
}

export default ProjectFolderFilterForm;
